import { ApprovalRequestProps } from '.';
import { TFunc } from '../../../../../hooks/useNamespacedTranslation';
import {
  ApprovalPathColleagueFragment,
  ApprovalRequestStatus,
} from '../../../__generated__/graphql';
import { getEmployeeInitialsFromName } from '../../../utils/employeeInitials';

export const mapApprovalPath = (
  src: ApprovalRequestProps[],
  currentEmployeeId: string,
  t: TFunc,
) => {
  if (!src || src.length === 0) {
    return null;
  }

  const recordEmployee = src[0].recordEmployee;
  const createdDate = src[0].CreatedDate;

  const employee = mapEmployee(
    t,
    recordEmployee,
    currentEmployeeId,
    ApprovalRequestStatus.Approved,
    createdDate,
    false,
  );

  const approvers = src.map((item) =>
    mapEmployee(
      t,
      item.approver,
      currentEmployeeId,
      item.flair__Approval_Status__c,
      item.CreatedDate,
      true,
    ),
  );

  return [employee, ...approvers];
};

const mapEmployee = (
  t: TFunc,
  employee: ApprovalPathColleagueFragment,
  currentEmployeeId: string,
  status: ApprovalRequestStatus,
  createdDate: string,
  isApprover: boolean,
) => {
  const i18Path = 'approvalPath';
  const isCurrentEmployee = employee.Id === currentEmployeeId;
  const name = isCurrentEmployee ? t(`${i18Path}.you`) : employee.Name;
  const additionalInfo1 = isApprover
    ? t(`${i18Path}.review`)
    : t(`${i18Path}.added`);
  const statusLabel = t(`approvalStatus.${status.toLowerCase()}`);

  return {
    id: employee.Id,
    isCurrentEmployee,
    name,
    avatarUrl: employee.avatar?.url ?? null,
    initials: getEmployeeInitialsFromName(employee.Name),
    departmentName: employee.department?.Name ?? null,
    status: status,
    statusLabel,
    additionalInfo1,
    createdDate,
    isApprover,
  };
};
